import React from 'react';
import SharedTranslations, { TranslationField } from "shared/components/Translations";
import { LocaleCode } from "shared/types/languages";
import TranslationInput from "shared/components/Translations/TranslationInput";
import { usePageDetails } from "../../../../context";
import { ManagedTranslations } from "../../../../context/types";

const Translations = () => {
  const { pageName, pageWebTitle, translations, setTranslations } = usePageDetails();

  const fields: TranslationField[] = [
    {
      key: ManagedTranslations.PageTitle,
      label: ManagedTranslations.PageTitle,
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={language === LocaleCode.en ? pageName?.input.value : value}
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              pageName?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    },
    {
      key: ManagedTranslations.PageWebTitle,
      label: ManagedTranslations.PageWebTitle,
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={language === LocaleCode.en ? pageWebTitle?.input.value : value}
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              pageWebTitle?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    },
  ];

  return (
    <SharedTranslations
      fields={fields}
      translations={translations}
      setTranslations={setTranslations}
    />
  );
};

export default Translations;